import { createAction } from 'redux-api-middleware';
import deep from 'deep-get-set';
import { createSelector } from 'reselect';
import config from '../../config';
import { buildHeaders } from '../buildAuthHeader';

// Actions
export const SHARE_STRATEGY_SELECT = 'SHARE_STRATEGY_SELECT';
export const SOCIAL_SHARING_MODAL_HIDE = 'SOCIAL_SHARING_MODAL_HIDE';
export const SOCIAL_SHARING_MODAL_SHOW = 'SOCIAL_SHARING_MODAL_SHOW';
export const AMAZON_SHARE_LOAD = 'AMAZON_SHARE_LOAD';
export const AMAZON_SHARE_LOAD_FAILURE = 'AMAZON_SHARE_LOAD_FAILURE';
export const AMAZON_SHARE_LOAD_SUCCESS = 'AMAZON_SHARE_LOAD_SUCCESS';
export const AMAZON_SHARE_STATUS_LOAD = 'AMAZON_SHARE_STATUS_LOAD';
export const AMAZON_SHARE_STATUS_LOAD_FAILURE = 'AMAZON_SHARE_STATUS_LOAD_FAILURE';
export const AMAZON_SHARE_STATUS_LOAD_SUCCESS = 'AMAZON_SHARE_STATUS_LOAD_SUCCESS';

// Action Creators
export function selectShareStrategy(strategy) {
  return {
    type: SHARE_STRATEGY_SELECT,
    strategy
  };
}

export function hideSocialShareModal() {
  return {
    type: SOCIAL_SHARING_MODAL_HIDE
  };
}

export function showSocialShareModal(mediaId, activeMedia = null) {
  return {
    type: SOCIAL_SHARING_MODAL_SHOW,
    mediaId,
    activeMedia
  };
}

export const saveAmazonShareSubmission = (payload) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.amazonShare}`,
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify(payload),
    credentials: 'include',
    types: [AMAZON_SHARE_LOAD, AMAZON_SHARE_LOAD_SUCCESS, AMAZON_SHARE_LOAD_FAILURE]
  });

export const fetchAmazonShareStatus = (mediaId) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.amazonShareStatus}/${mediaId}/amazon-videos`,
    method: 'GET',
    headers: buildHeaders(),
    credentials: 'include',
    types: [
      AMAZON_SHARE_STATUS_LOAD,
      AMAZON_SHARE_STATUS_LOAD_SUCCESS,
      AMAZON_SHARE_STATUS_LOAD_FAILURE
    ]
  });

// Reducers
const initialState = {
  shouldShowSocialShareModal: false,
  selectedShareStrategy: 'YOUTUBE',
  mediaIdToShare: null,
  activeMedia: null,
  isAmazonShareStatusLoading: false,
  isAmazonShareStatusLoaded: false,
  isAmazonShareStatusError: false,
  shareStatusExists: false,
  shares: []
};

export function shareReducer(state = initialState, action) {
  switch (action.type) {
    case SHARE_STRATEGY_SELECT: {
      const newState = {
        ...state,
        selectedShareStrategy: action.strategy
      };

      return newState;
    }

    case SOCIAL_SHARING_MODAL_SHOW: {
      const newState = {
        ...state,
        shouldShowSocialShareModal: true,
        selectedShareStrategy: 'YOUTUBE',
        mediaIdToShare: action.mediaId,
        activeMedia: action.activeMedia,
        shares: [] // wipe out shares so we have a clean slate
      };

      return newState;
    }

    case SOCIAL_SHARING_MODAL_HIDE: {
      const newState = {
        ...state,
        shouldShowSocialShareModal: false,
        mediaIdToShare: null,
        activeMedia: null
      };

      return newState;
    }

    case AMAZON_SHARE_STATUS_LOAD: {
      const newState = {
        ...state,
        isAmazonShareStatusLoading: true,
        isAmazonShareStatusLoaded: false,
        isAmazonShareStatusError: false
      };

      return newState;
    }

    case AMAZON_SHARE_STATUS_LOAD_SUCCESS: {
      // Set the strategy
      action.payload.strategy = 'AMAZON';

      const newState = {
        ...state,
        isAmazonShareStatusLoading: false,
        isAmazonShareStatusLoaded: true,
        isAmazonShareStatusError: false,
        shares: [...state.shares, action.payload]
      };

      return newState;
    }

    case AMAZON_SHARE_STATUS_LOAD_FAILURE: {
      const newState = {
        ...state,
        isAmazonShareStatusLoading: false,
        isAmazonShareStatusLoaded: false,
        isAmazonShareStatusError: true
      };

      return newState;
    }

    default: {
      return state;
    }
  }
}

// Selectors
export const getShareState = createSelector(
  (state) => state,
  (state) => state.get('share')
);

export const getShouldShowSocialShareModal = createSelector(getShareState, (state) =>
  deep(state, 'shouldShowSocialShareModal')
);

export const getMediaIdToShare = createSelector(getShareState, (state) =>
  deep(state, 'mediaIdToShare')
);

export const getActiveMedia = createSelector(getShareState, (state) => state?.activeMedia);

export const getSelectedShareStrategy = createSelector(getShareState, (state) =>
  deep(state, 'selectedShareStrategy')
);

export const getShareStatusInfo = createSelector(
  getShareState,
  (state) => state.shares.find((s) => s.strategy === state.selectedShareStrategy) || null
);



// WEBPACK FOOTER //
// ./src/redux/modules/share.js